import { styled } from '@mui/material';

import { BaseButton } from './BaseButton';

export const SecondaryButton = styled(BaseButton)(({ theme }) => ({
  color: 'currentcolor',

  '&, &:hover, &.Mui-disabled': {
    borderColor: 'currentcolor',
  },

  '&:hover, &:focus': {
    backgroundColor: 'rgb(10 36 44 / 0.06)',
  },

  '&.Mui-disabled': {
    cursor: 'not-allowed',
    color: theme.palette.brand.grey700,
    backgroundColor: 'transparent',
  },
}));
